export default __webpack_public_path__ + "static/media/1-2-3.44eb6d7f.jpg";